/**
 * When a title overflows, run a continuous pan animation and set --pan-distance.
 * Supports project cards [data-project-title-scroll] and production [data-production-title-scroll].
 */
const TITLE_SCROLL_CONFIG = [
  { scrollAttr: "data-project-title-scroll", textClass: "c-project__title-text" },
  { scrollAttr: "data-production-title-scroll", textClass: "c-production__title-text" },
];

function initTitlePanIn(container) {
  const root = container?.querySelectorAll ? container : document;
  TITLE_SCROLL_CONFIG.forEach(({ scrollAttr, textClass }) => {
    root.querySelectorAll(`[${scrollAttr}]`).forEach((scrollEl) => {
      const textEl = scrollEl.querySelector(`.${textClass}`);
      if (!textEl) return;

      const update = () => {
        const overflow = scrollEl.scrollWidth - scrollEl.clientWidth;
        if (overflow > 0) {
          scrollEl.classList.add("is-overflowing");
          textEl.style.setProperty("--pan-distance", `${overflow}px`);
          textEl.classList.add("is-panning");
        } else {
          scrollEl.classList.remove("is-overflowing");
          textEl.style.removeProperty("--pan-distance");
          textEl.classList.remove("is-panning");
        }
      };

      update();
      window.addEventListener("resize", update);
    });
  });
}

export function initProjectTitlePan(container) {
  initTitlePanIn(container ?? document);
}
